<template v-if="!loading">

    <v-dialog v-model="deletedialog"  max-width="550px">
        <v-btn fab dark small color="red" slot="activator"><v-icon>delete</v-icon>
        </v-btn> 
          <v-card>
            <v-container >
              <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="deletedialog=false;"> <v-icon>close</v-icon></v-btn>
              </v-flex>
                <h2 style="text-align:center;">Are you sure you want to delete it ?</h2>
                <div style="margin-left:30%; margin-top:5%;" >
                 <v-spacer></v-spacer>
                    <v-btn  @click="deletedialog=false;" color="white" style="color:black; " >Cancel </v-btn> 
                    <v-btn  @click="onDelete" color="red" style="color:white;" > Delete </v-btn> 
               </div>
            </v-container>
          </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {text: Object},
  data() {
    return {
        deletedialog: false,
    }
  },
  computed: {
    loading(){
      return this.$store.getters.loading;
    }  
  },
  methods: {
      onDelete(){
        this.deletedialog = false;  

        console.log(this.text) 
        this.$store.dispatch('deleteText', this.text);
        this.$store.dispatch('loadSpotContent', Number(this.$route.params.id));
      }
    
  }

}
</script>


// WEBPACK FOOTER //
// src/components/edit/deleteText.vue